import { render } from "./MainListUserAssists.vue?vue&type=template&id=38185167&scoped=true"
import script from "./MainListUserAssists.vue?vue&type=script&lang=js"
export * from "./MainListUserAssists.vue?vue&type=script&lang=js"

import "./MainListUserAssists.vue?vue&type=style&index=0&id=38185167&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38185167"]])

export default __exports__